<script lang="ts" context="module">
	/*
	 * FancyBox - jQuery Plugin
	 * Simple and fancy lightbox alternative
	 *
	 * Examples and documentation at: http://fancybox.net
	 *
	 * Copyright (c) 2008 - 2010 Janis Skarnelis
	 * That said, it is hardly a one-person project. Many people have submitted bugs, code, and offered their advice freely. Their support is greatly appreciated.
	 *
	 * Version: 1.3.4 (11/11/2010)
	 * Requires: jQuery v1.3+
	 *
	 * Dual licensed under the MIT and GPL licenses:
	 *   http://www.opensource.org/licenses/mit-license.php
	 *   http://www.gnu.org/licenses/gpl.html
	 */
	import { onMount } from "svelte";
	import { initFancyBox } from "./fancybox";
</script>

<script lang="ts">
	onMount(() => {
		initFancyBox();
	});
</script>

<div
	class="pointer-events-none fixed inset-0 flex transform flex-col items-center justify-center bg-black bg-opacity-25 opacity-0 transition-all duration-300"
	id="fancy-box-container">
	<div class="relative scale-75 transform rounded bg-white p-4 shadow-xl transition-all duration-300">
		<div class="relative">
			<img class="loading" alt="Loading indicator" />
			<div class="loading-thingy"></div>
		</div>
		<p class="mt-4 text-center text-md text-gray-500"></p>
		<i class="material-icons sm-clickable absolute right-2 top-2 rounded bg-white">close</i>
	</div>
</div>

<style>
	:global(#fancybox-loading) {
		position: fixed;
		top: 50%;
		left: 50%;
		width: 40px;
		height: 40px;
		margin-top: -20px;
		margin-left: -20px;
		cursor: pointer;
		overflow: hidden;
		z-index: 24;
		display: none;
	}

	:global(#fancybox-loading div) {
		position: absolute;
		top: 0;
		left: 0;
		width: 40px;
		height: 480px;
		background-image: url("/images/fancybox/fancybox.png");
	}

	:global(#fancybox-overlay) {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 20;
		display: none;
	}

	:global(#fancybox-tmp) {
		padding: 0;
		margin: 0;
		border: 0;
		overflow: auto;
		display: none;
	}

	:global(#fancybox-wrap) {
		position: absolute;
		top: 0;
		left: 0;
		padding: 20px;
		z-index: 21;
		outline: none;
		display: none;
		box-sizing: content-box;
	}

	:global(#fancybox-outer) {
		position: relative;
		width: 100%;
		height: 100%;
		background: #fff;
		box-sizing: content-box;
	}

	:global(#fancybox-content) {
		width: 0;
		height: 0;
		padding: 0;
		outline: none;
		position: relative;
		overflow: hidden;
		z-index: 22;
		border: 0 solid #fff;
	}

	:global(#fancybox-hide-sel-frame) {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: transparent;
		z-index: 21;
		box-sizing: content-box;
	}

	:global(#fancybox-close) {
		position: absolute;
		top: -15px;
		right: -15px;
		width: 30px;
		height: 30px;
		background: transparent url("/images/fancybox/fancybox.png") -40px 0;
		cursor: pointer;
		z-index: 23;
		display: none;
		box-sizing: content-box;
	}

	:global(#fancybox-error) {
		color: #444;
		font: normal 12px/20px Arial;
		padding: 14px;
		margin: 0;
		box-sizing: content-box;
	}

	:global(#fancybox-img) {
		max-width: 100%;
		max-height: 100%;
		display: block;
		padding: 0;
		margin: 0 auto;
		border: none;
		outline: none;
		line-height: 0;
		vertical-align: top;
		box-sizing: content-box;
	}

	:global(#fancybox-frame) {
		width: 100%;
		height: 100%;
		border: none;
		display: block;
		box-sizing: content-box;
	}

	:global(#fancybox-left),
	:global(#fancybox-right) {
		position: absolute;
		bottom: 0;
		height: 100%;
		width: 35%;
		cursor: pointer;
		outline: none;
		background: transparent url("/images/inline/fancybox/blank.gif");
		z-index: 22;
		display: none;
	}

	:global(#fancybox-left) {
		left: 0;
	}

	:global(#fancybox-right) {
		right: 0;
	}

	:global(#fancybox-left-ico),
	:global(#fancybox-right-ico) {
		position: absolute;
		top: 50%;
		left: -9999px;
		width: 30px;
		height: 30px;
		margin-top: -15px;
		cursor: pointer;
		z-index: 22;
		display: block;
	}

	:global(#fancybox-left-ico) {
		background-image: url("/images/fancybox/fancybox.png");
		background-position: -40px -30px;
	}

	:global(#fancybox-right-ico) {
		background-image: url("/images/fancybox/fancybox.png");
		background-position: -40px -60px;
	}

	:global(#fancybox-left:hover),
	:global(#fancybox-right:hover) {
		visibility: visible; /* IE6 */
	}

	:global(#fancybox-left:hover span) {
		left: 20px;
	}

	:global(#fancybox-right:hover span) {
		left: auto;
		right: 20px;
	}

	:global(.fancybox-bg) {
		position: absolute;
		padding: 0;
		margin: 0;
		border: 0;
		width: 20px;
		height: 20px;
		z-index: 19;
	}

	:global(#fancybox-bg-n) {
		top: -20px;
		left: 0;
		width: 100%;
		background-image: url("/images/inline/fancybox/fancybox-x.png");
	}

	:global(#fancybox-bg-ne) {
		top: -20px;
		right: -20px;
		background-image: url("/images/fancybox/fancybox.png");
		background-position: -40px -162px;
	}

	:global(#fancybox-bg-e) {
		top: 0;
		right: -20px;
		height: 100%;
		background-image: url("/images/inline/fancybox/fancybox-y.png");
		background-position: -20px 0;
	}

	:global(#fancybox-bg-se) {
		bottom: -20px;
		right: -20px;
		background-image: url("/images/fancybox/fancybox.png");
		background-position: -40px -182px;
	}

	:global(#fancybox-bg-s) {
		bottom: -20px;
		left: 0;
		width: 100%;
		background-image: url("/images/inline/fancybox/fancybox-x.png");
		background-position: 0px -20px;
	}

	:global(#fancybox-bg-sw) {
		bottom: -20px;
		left: -20px;
		background-image: url("/images/fancybox/fancybox.png");
		background-position: -40px -142px;
	}

	:global(#fancybox-bg-w) {
		top: 0;
		left: -20px;
		height: 100%;
		background-image: url("/images/inline/fancybox/fancybox-y.png");
	}

	:global(#fancybox-bg-nw) {
		top: -20px;
		left: -20px;
		background-image: url("/images/fancybox/fancybox.png");
		background-position: -40px -122px;
	}

	:global(#fancybox-title) {
		box-sizing: content-box;
		font-family: "Roboto", "Lucida Grande", arial, sans-serif;
		z-index: 5;
	}

	:global(#fancybox-title .image-info) {
		background: #eee;
		padding: 15px;
	}

	:global(#fancybox-title .image-info .image-title) {
		font-size: 20px;
		font-weight: 300;
		color: #333;
	}

	:global(#fancybox-title .image-info .image-description) {
		margin-top: 8px;
		font-size: 13px;
		color: #888;
	}

	:global(#fancybox-title .image-info .image-description a) {
		text-decoration: underline;
		color: #1c6e98;
	}

	:global(#fancybox-title .image-info .image-description strong) {
		font-weight: bold;
	}

	:global(#fancybox-title .image-info .image-description em) {
		font-style: italic;
	}

	:global(#fancybox-title .image-info .image-description u) {
		text-decoration: underline;
	}

	:global(#fancybox-title .image-info .image-description ul),
	:global(#fancybox-title .image-info .image-description ol) {
		padding-left: 30px;
	}

	:global(#fancybox-title .image-info .image-description ul),
	:global(#fancybox-title .image-info .image-description li) {
		list-style: disc;
	}
	:global(#fancybox-title .image-info .image-description ol),
	:global(#fancybox-title .image-info .image-description li) {
		list-style: decimal;
	}

	.fancybox-title-inside {
		padding-bottom: 10px;
		text-align: center;
		color: #333;
		background: #fff;
		position: relative;
	}

	.fancybox-title-outside {
		padding-top: 10px;
		color: #fff;
	}

	.fancybox-title-over {
		position: absolute;
		bottom: 0;
		left: 0;
		color: #fff;
		text-align: left;
	}

	:global(#fancybox-title-over) {
		padding: 10px;
		background-image: url("/images/inline/fancybox/fancy_title_over.png");
		display: block;
	}

	:global(.fancybox-title-float) {
		position: absolute;
		left: 0;
		bottom: -20px;
		height: 32px;
	}

	:global(#fancybox-title-float-wrap) {
		border: none;
		border-collapse: collapse;
		width: auto;
	}

	:global(#fancybox-title-float-wrap td) {
		border: none;
		white-space: nowrap;
	}

	:global(#fancybox-title-float-left) {
		padding: 0 0 0 15px;
		background: url("/images/fancybox/fancybox.png") -40px -90px no-repeat;
	}

	:global(#fancybox-title-float-main) {
		color: #fff;
		line-height: 29px;
		font-weight: bold;
		padding: 0 0 3px 0;
		background: url("/images/inline/fancybox/fancybox-x.png") 0px -40px;
	}

	:global(#fancybox-title-float-right) {
		padding: 0 0 0 15px;
		background: url("/images/fancybox/fancybox.png") -55px -90px no-repeat;
	}

	/***** Images lightbox hover effects *****/

	:global(.fancy-pic) {
		position: relative;
		display: block;
	}

	:global(.fancy-pic .pic-border) {
		transition: background-color 0.5s;
	}

	:global(.fancy-pic:hover .pic-border) {
		background: rgba(0, 0, 0, 0.2);
	}

	:global(.pic-border .magnify) {
		background: url(/images/inline/magnify.png) no-repeat center center;
		opacity: 0;
		position: absolute;
		transition: opacity 0.5s;
		height: 100%;
		width: 100%;
	}

	:global(.fancy-pic:hover .magnify) {
		opacity: 1;
	}

	#fancy-box-container {
		z-index: 1000;
	}

	#fancy-box-container img {
		max-height: 80vh;
		max-width: 80vw;
		min-width: var(--min-width, 20vw);
		min-height: var(--min-height, 150px);
		background: #ccc no-repeat center center;
		background-size: cover;
		background-image: var(--loading-bg);
		overflow: hidden;
	}

	#fancy-box-container img.loading + div {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		display: flex;
		backdrop-filter: blur(20px);
	}
</style>
